import {
  CLEAR_IMPORT_ENTITY_STORE,
  INITIATE_IMPORT_PROCESS,
  SET_IMPORT_ERROR,
  SET_IMPORT_MODAL_OPEN,
  SET_IMPORT_STEP,
  SET_MASTER_SETUP_IMPORT_DATA,
  SET_MASTER_SETUP_IMPORT_LOADING,
  SET_MODAL_IN_FILE_PROCESSING_STATE,
} from '../actions/BulkImportActions';
import { IMPORT_STEPS } from '../constants/MasterSetupConstants';

const initialState = {
  isModalOpen: false,
  importEntities: {},
};

const initialImportConfig = {
  isLoading: false,
  importStep: 0,
  hasImportError: false,
  importKey: '',
  importStatuses: [],
  errorMessage: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INITIATE_IMPORT_PROCESS: {
      const { payload } = action;

      return {
        importEntities: {
          ...state.importEntities,
          [payload.entityName]: initialImportConfig,
        },
        isModalOpen: true,
      };
    }

    case SET_MODAL_IN_FILE_PROCESSING_STATE: {
      const { payload } = action;

      return {
        importEntities: {
          ...state.importEntities,
          [payload.entityName]: {
            ...initialImportConfig,
            isLoading: true,
            importStep: IMPORT_STEPS.FILE_PROCESSING,
            importKey: payload.importKey,
          },
        },
        isModalOpen: true,
      };
    }

    case SET_IMPORT_MODAL_OPEN: {
      const { payload } = action;

      return {
        ...state,
        isModalOpen: payload.flag,
      };
    }

    case SET_IMPORT_STEP: {
      const { payload } = action;

      return {
        ...state,
        importEntities: {
          ...state.importEntities,
          [payload.entityName]: {
            ...state.importEntities[payload.entityName],
            importStep: payload.step,
          },
        },
      };
    }

    case SET_MASTER_SETUP_IMPORT_DATA: {
      const { payload } = action;

      return {
        ...state,
        importEntities: {
          ...state.importEntities,
          [payload.entityName]: {
            ...state.importEntities[payload.entityName],
            importKey: payload.importKey,
            importStatuses: payload.importStatuses,
          },
        },
      };
    }

    case SET_MASTER_SETUP_IMPORT_LOADING: {
      const { payload } = action;

      return {
        ...state,
        importEntities: {
          ...state.importEntities,
          [payload.entityName]: {
            ...state.importEntities[payload.entityName],
            isLoading: payload.flag,
          },
        },
      };
    }

    case SET_IMPORT_ERROR: {
      const { payload } = action;

      return {
        ...state,
        importEntities: {
          ...state.importEntities,
          [payload.entityName]: {
            ...state.importEntities[payload.entityName],
            hasImportError: payload.flag,
            errorMessage: payload.message,
          },
        },
      };
    }

    case CLEAR_IMPORT_ENTITY_STORE: {
      const { payload } = action;

      return {
        ...state,
        importEntities: {
          ...state.importEntities,
          [payload.entityName]: initialImportConfig,
        },
      };
    }

    default:
      return state;
  }
};
